// Client API typé pour appeler le backend Hono.
// Toutes les requêtes passent par cette fonction unique, qui ajoute
// automatiquement les credentials et lève une erreur en cas d'échec HTTP.

export class ApiError extends Error {
  constructor(
    message: string,
    public status: number,
    public body?: unknown,
  ) {
    super(message)
    this.name = 'ApiError'
  }
}

export async function api<T = unknown>(
  path: string,
  options: RequestInit = {},
): Promise<T> {
  const response = await fetch(path, {
    ...options,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

  if (!response.ok) {
    let body: unknown
    try {
      body = await response.json()
    } catch {
      body = await response.text()
    }
    throw new ApiError(
      `Erreur HTTP ${response.status} sur ${path}`,
      response.status,
      body,
    )
  }

  return response.json() as Promise<T>
}
